import React, { useState } from 'react';
import PullToRefresh from "react-simple-pull-to-refresh";
import { RefreshLoadingModal } from "./RefreshLoadingModal";
import LandingPage from "./LandingPage";

// Wrapper component that adds pull-to-refresh to the landing page only
function LandingPageWithRefresh({ twitterUser, setTwitterUser }) {
  const [showModal, setShowModal] = useState(false);

  const handleRefresh = async () => {
    return new Promise((resolve) => {
      // Show modal immediately on every refresh
      setShowModal(true);

      // Wait at least 1000ms before reloading to ensure animation shows
      setTimeout(() => {
        window.location.reload();
        resolve();
      }, 1000);
    });
  };

  return (
    <>
      <PullToRefresh
        onRefresh={handleRefresh}
        pullingContent=""
        refreshingContent=""
        className="min-h-screen"
      >
        <LandingPage twitterUser={twitterUser} setTwitterUser={setTwitterUser} />
      </PullToRefresh>

      {/* Refresh loading modal - shows with guaranteed 1s display time */}
      <RefreshLoadingModal show={showModal} />
    </>
  );
}

export default LandingPageWithRefresh;
